import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ObjectModel} from '../../../shared/models/object.model';
import { ShareService } from 'src/moti/services/share.service';
import { PermissionsService } from '../../../core/services/permissions.service';
import { ShadeToolsService } from '../../../core/services/shade-tools.service';
import { Permission } from '../../../shared/models/fga/permission';
import { SessionService } from '../../../core/services/session.service';

@Component({
    selector: 'motn-share-button',
    templateUrl: './share-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./share-button.component.scss'],
})
export class ShareButtonComponent {
  @Input() object: ObjectModel;

  constructor(
    private shareService: ShareService,
    private permissionsService: PermissionsService,
    private shadeTools: ShadeToolsService,
    private session: SessionService,
  ) {}

  showManager(): void {
    this.permissionsService.queryPermissions({
      UserID: this.session.userId,
      ObjectID: this.object.id,
      ObjectType: this.object.type,
      Permissions: [Permission.CAN_SHARE]
    }).subscribe({
      next: (response) => {
        const canShare = response.Results.find(r => r.Permission === Permission.CAN_SHARE)?.Allowed;
        if (canShare) {
          this.shareService.showShareManagerForObject$.next(this.object);
        } else {
          this.shadeTools.errorDialog('You do not have permission to share this item.');
        }
      },
      error: () => {
        this.shadeTools.errorDialog('Unable to check sharing permissions.');
      }
    });
  }
}
